export default {
  data: () => ({
    setPlanInterval: ''
  }),
  methods: {
    checkIsFree () {
      return this.getterPlan.id === 1
    },
    checkIsPlan (name) {
      return this.getterPlan.id_text === name
    },
    // O gerrerAccesses é passado nos parametro para poder passar os valores direto como feito no beforeEnter das rotas
    checkPlanAccess (access, type, currentValue = -1, getterAccesses = this.getterAccesses) {
      let hasAccess = true
      let Accesses = getterAccesses.find((res) => {
        return (res.id_text === access && res.hasOwnProperty(type))
      })
      if (Accesses) {
        // hasAccess = Accesses[type] serve para identificar acessos booleanos como has, active etc.
        hasAccess = Accesses[type]
        switch (type) {
          case 'qtd':
            hasAccess = (currentValue < Accesses[type])
            break
          case 'size':
            hasAccess = (currentValue < Accesses[type])
            break
          case 'not_connected':
            hasAccess = (currentValue < Accesses[type])
            break
        }
      }
      return hasAccess
    },
    checkQtdAccess (access, currentValue = -1, twoMessages = true, getterAccesses = this.getterAccesses, field = 'qtd') {
      let hasAccess = true
      let Accesses = getterAccesses.find((res) => {
        return (res.id_text === access && res.hasOwnProperty(field))
      })
      if (Accesses) {
        let leftover = Accesses[field] - currentValue
        if (leftover <= 0) {
          this.$store.commit('snackbarPlan/change_values', {
            text: `Foi alcançado o limite de registros do seu plano!`,
            dialog: true
          })
        } else if (leftover <= 5 && twoMessages) {
          this.$store.commit('snackbarPlan/change_values', {
            text: `Faltam ${leftover} registros para alcançar o limite do seu plano!`,
            dialog: true
          })
        }
      }
      return hasAccess
    },
    checkSizeAccess (access, currentValue = -1, twoMessages = true, getterAccesses = this.getterAccesses) {
      let hasAccess = true
      let Accesses = getterAccesses.find((res) => {
        return (res.id_text === access && res.hasOwnProperty('size'))
      })
      if (Accesses) {
        // transforma em megabytes
        let size = currentValue / 1048576
        let leftover = Accesses['qtd'] - size
        if (leftover === 0) {
          this.$store.commit('snackbarPlan/change_values', {
            text: `Foi alcançado o limite de volume do seu plano!`,
            dialog: true
          })
        } else if (leftover <= 100 && twoMessages) {
          this.$store.commit('snackbarPlan/change_values', {
            text: `Faltam ${leftover} para alcançar o limite do seu plano!`,
            dialog: true
          })
        }
      }
      return hasAccess
    }
  },
  computed: {
    getterPlan () {
      return this.$store.getters[`plan/value`]
    },
    getterAccesses () {
      return this.$store.getters[`plan/accesses`]
    }
  }
}



// WEBPACK FOOTER //
// ./src/mixin/plan.js